<div id="standalone-page" role="backoffice-index" style="background-image: url('assets/imgs/ticket-banner-default.png');">
  <div id="auth-wrapper" class="container">

	<div class="d-flex justify-content-center d-flex align-items-center d-flex align-content-center">
		<a [routerLink]="['/']"><img src="assets/imgs/favicon.png" alt="Akces.fr"></a>
		<header>
			<h1 class="title inline-block">La page demandée n'exsite pas :(</h1>
		</header>	
	</div>

  </div>
</div>

